/* eslint-disable max-len */
export default {
  cfmoto: {
    AIReview: 'Recenze AI',
    AIReviewFailed: 'Kontrola AI se nezdařila',
    AIReviewPassed: 'Recenze AI prošla',
    AIReviewStatus: 'Stav kontroly AI',
    AIReviewing: 'Probíhá revize AI',
    America: {},
    CheckSupportInstall: 'Zkontrolujte, zda je podporována modernizace',
    ImporterCommunityDisplayName: 'Zobrazené jméno komunity dovozce',
    ImporterContactEmail: 'Kontaktní e-mail dovozce',
    IndicatorLight: 'Indikátor světla',
    Instruction: 'Oznámení',
    MostPicture4OrVideo: '(Maximálně 4 obrázky / 1 video)',
    PleaseContactPersonnelCommunicating: 'Kontaktujte prosím personál CFMOTO pro komunikaci',
    USD: {},
    UnbindingApplicationCommitment: {},
    aboutAccount: 'O účtu',
    aboutVehicle: 'O vozidle',
    accountApplyRejected: 'Žádost o smazání účtu zamítnuta',
    accountCancel: 'Žádost o smazání účtu',
    accountDeletExplain: 'Průvodce odstraněním účtu',
    accountDelete: 'Odstranit účet',
    accountDeleted: 'Smazaný účet',
    accountFormatError: 'Nesprávný formát účtu/uživatel neexistuje. Prosím, Shodujte se odpovídajícím psaní textu na základě skutečné příčiny',
    action: 'Operace',
    actionFail: 'operace selhala',
    actionSuccess: 'Operace proběhla úspěšně',
    activeScore: 'Aktivní bodování',
    activeTrigger: 'Uživatelé aktivně spouštějí (O aplikaci – Přejít na hodnocení)',
    activity: 'Aktivita',
    activityCancel: 'Zrušení události',
    activityCover: 'Obálka akce',
    activityDetails: 'Podrobnosti o akci',
    activityId: 'ID aktivity',
    activityList: 'Seznam aktivit',
    activityManagement: 'Organizace akcí',
    activitySearch: 'Aktivní vyhledávání',
    activityTime: 'Čas události',
    activityTitle: 'Název akce',
    activityVenue: 'Místo konání akce',
    adaptable: 'Fity pro',
    add: 'Přidat',
    addAccountDeletExplain: 'Přidat oznámení o smazání účtu',
    addAuthenticationTime: 'Přidat čas ověření',
    addDataDeletExplain: 'Oznámení o smazání dat',
    addEmail: 'Nový Email',
    addExhibitionCategory: {},
    addExhibitionSeries: {},
    addInformationCategory: 'Přidat novou kategorii informací',
    addInformationContent: 'Přidejte nový informační obsah',
    addKolUserAuthentication: 'Přidat ověření uživatele KOL',
    addPicture: 'Přidat obrázek',
    addPrivacyAgreement: 'Přidejte smlouvu o ochraně osobních údajů',
    addPrivacySubmitSure: 'Datum účinnosti a popis změn nových zásad ochrany osobních údajů nelze po odeslání upravit. Potvrďte odeslání.',
    addPushConfiguration: 'Přidání konfiguraci push',
    addQuestion: {},
    addSdkStaement: 'Přidat prohlášení SDK',
    addServiceIntroduce: 'Úvod do nových služeb',
    addShowroomModel: 'Přidat modely showroomu',
    addThisUser: 'Přidat tohoto uživatele',
    addTopic: 'Přidání motivu',
    addUser: 'Přidání uživatelů',
    addUserAgreement: 'Přidat uživatelskou smlouvu',
    addUserRole: 'Přidat uživatelskou roli',
    addVehicleModel: 'Nové modely',
    addVehicleModelCategory: 'Nová kategorie vozidel',
    addVideo: 'Přidat video',
    addedBy: 'Přidal',
    additionalFeedback: 'Další zpětná vazba',
    administratorUnbind: 'Odpárovat administrátora',
    afternoon: 'Odpoledne',
    agreeSignOut: 'Souhlas s ukončením',
    agreementContent: 'Dohoda',
    all: 'Celý',
    allArea: 'Cílová země/oblast',
    allComment: 'Všechny komentáře',
    allImportSuccess: 'Import dokončen. Vše úspěšně importováno',
    allUser: 'Všichni uživatelé',
    allVehicleModel: 'Všechny modely',
    alreadyOver: 'Všechno tady',
    android: 'Android',
    answer: {},
    answerOta1: 'OTA znamená, že vozidlo stahuje nejnovější firmwarový software z cloudu prostřednictvím mobilní sítě a vozidlo můžete aktualizovat online prostřednictvím služby CFMOTO RIDE, abyste neustále optimalizovali zážitek z jízdy',
    answerOta2: 'Když se zobrazí nová verze tft, kterou lze upgradovat, obdržíte upozornění na aktualizaci. Pokud se v dolní části aktuální stránky zobrazí %s, znamená to, že tft displej vozidla není třeba upgradovat.',
    answerOta3: 'Můžete kliknout na %s v pravém horním rohu, abyste se předem dozvěděli další pokyny k OTA operacím',
    anyCar: 'Máte auto?',
    appRating: 'Správa skórovacího mechanismu',
    appType: 'Telefonní systém',
    appVersion: 'Verze APP',
    applicableCountry: {},
    applicableCountryName: {},
    applyTime: 'Čas přihlášení',
    applyUnbinding: 'Použít rozvázání',
    appointmentReleaseTime: 'Čas uvolnění schůzky',
    approval: 'Potvrdit',
    arrivalNumberDescription: 'Skutečný počet příchozích na terminál zařízení po odeslání oznamovací zprávy (příchozí po 5 dnech nebudou započítána)',
    arrivalNumberVolume: 'Počet příchozích',
    askAllowUserSpeakInCommunity: 'Povolit zablokovanému uživateli přidávat příspěvky do komunity',
    askApproveIt: 'Schválit to',
    askDeleteCategory: {},
    askDeleteInformactionCategory: 'Zda odstranit tuto kategorii informací',
    askDeleteInformationContent: 'Zda odstranit informační obsah',
    askDeleteKolUserAuthentication: 'Jste si jisti, že chcete smazat toto ověření uživatele KOL?',
    askDeleteQuestion: {},
    askDeleteThisActivity: 'Smazat tuto aktivitu',
    askDeleteThisBanner: 'Smazat tento Banner',
    askDeleteThisComment: 'Opravdu chcete tento komentář smazat',
    askDeleteThisPost: 'Smazat tento příspěvek',
    askDeleteThisTopic: 'Smazat toto téma',
    askDeleteVehicleType: 'Určitě smažete model vozidla',
    askDeleteVehicleTypeCategory: 'Zda odstranit tuto kategorii modelu',
    askDeleteVehicleTypeDetails: 'Zda odstranit podrobnosti o modelu auta',
    askDeleteVehicleTypeSeries: 'Zda odstranit tuto modelovou řadu',
    askLogout: 'Opravdu chcete opustit systém?',
    askNotApproveIt: 'Neschvalujete to',
    askSaveSettings: 'Nastavení ještě nebylo uloženo, chcete je uložit?',
    associatedPostNumber: 'Počet souvisejících příspěvků',
    associatedPosts: 'Související články',
    associatedVehicle: 'přidružené vozidlo',
    assoclatedContent: 'Přidružený obsah',
    atmosphereCContent: 'Nastavení ještě nebylo uloženo, chcete je uložit?',
    atmosphereContent1Msg1: 'Po zapnutí funkce mobil zapne Bluetooth a APP běží dál. Při přiblížení k vozidlu z dálky do blízkosti lze vozidlo automaticky odemknout a zapnout.',
    atmosphereContent1Msg2: 'Pokud se normálně neodemkne a nezapne, odemkněte a zapněte stisknutím tlačítka napájení vozidla',
    atmosphereContent1Msg3: 'Automatické odemykání blízkosti bude spuštěno pouze jednou před odpojením bluetooth',
    atmosphereContent2Msg1: 'Po zapnutí funkce se vozidlo automaticky vypne po 5 sekundách po třech podmínkách vypnutého vozidla, rychlost vozidla je 0 a chrám je upuštěn',
    atmosphereContent2Msg2: 'Spuštění vozidla během období automatického vypnutí není rychlost vozidla 0 nebo odložení chrámu zruší automatické vypnutí',
    atmosphereContent3Msg1: 'Po zapnutí funkce, při vypnutí vozidla se mobilní telefon zapne Bluetooth a APP běží dál nebo nese fyzický klíč. Při přiblížení k vozidlu z dálky do blízkosti blikají světla vozidla, aby přivítali hosty',
    atmosphereContent3Msg2: 'Aby se zabránilo častým spouštěčům ve ztrátě výkonu vozidla, po spuštění uvítací funkce dvakrát do 30 sekund se obnoví až o 30 minut později',
    atmosphereContent4Msg1: 'Po zapnutí funkce se automaticky rozsvítí dálková a potkávací světla na 10 sekund po vypnutí vozidla',
    atmosphereIntroduce1: 'V blízkosti pokynů pro automatické odemykání',
    atmosphereIntroduce2: 'pokyny pro automatické vypnutí',
    atmosphereIntroduce3: 'Pokyny pro automatické probuzení',
    atmosphereIntroduce4: 'Zpožděné zhasnutí světel',
    atmosphereSetINfo: 'Nová nastavení se projeví během 1-3 minut po zapnutí vozidla, ujistěte se, že je vozidlo v dobré pozici signálu',
    auditStatus: 'stav schválení',
    authenticatedName: 'Ověřené jméno',
    avatar: 'Profil Uživatele',
    backApply: 'stáhnout žádost',
    backApplySuccess: 'stažení žádosti úspěšné',
    backHome: 'Zpět na domovskou stránku',
    bannerDisplayImages: 'Bannerový obrázek',
    bannerList: 'Seznam bannerů',
    bannerManagement: 'Správa bannerové reklamy',
    bannerPictrure: 'Výkres banneru',
    bannerSearch: 'Vyhledávání bannerů',
    bannerTitle: 'Název banneru',
    batchImport: 'Dávkový import',
    batchUser: 'Dávkoví uživatelé',
    beijingTime: 'Čas UTC+8',
    belogCategory: 'kategorie',
    belongCategory: {},
    bindDevice: 'Vázecí zařízení',
    bindVehicle: 'Svázat vozidlo',
    bindingStatus: 'Stav spárování',
    bindingText1: '1.\tTelematické služby',
    bindingText10: '1.1.2.\tPoskytování plánování trasy během navigace, včetně výpočtu vzdálenosti mezi vozidly a pěší navigace za účelem vyhledání vozidla .',
    bindingText11: '1.2.\tZasílání nezbytných oznámení Zákazníkovi na základě podmínek vozidla.',
    bindingText12: '1.2.1.\tCFMOTO ukončí upozornění Zákazníka na údržbu vozidla (např. na základě celkové vzdálenosti, kterou Zákazník ujel, času, kdy Zákazník vozidlo koupil, požadavků na čas nebo dojezdovou vzdálenost pro údržbu vozidla) .',
    bindingText13: '1.2.2.\tNa základě údajů o vozidle CFMOTO zašle Zákazníkovi upozornění na abnormální situaci; včetně analýzy dat OEM (v závislosti na modelu) pro zajištění péče o zákazníky a následné optimalizace vozidla .',
    bindingText14: '1.3.\tPodpora při analýze příčiny nehody, pokud Zákazník nahlásí vážnou nehodu Vozidla.',
    bindingText15:
      '1.3.1.\tV případě vážné nehody Vozidla, např. když se Vozidlo během jízdy převrátí nebo převrátí na bok, podpoří CFMOTO Zákazníka na požádání při objasnění, zda je nehoda způsobena závadou na Vozidlo nebo jinými okolnostmi. Požadavek musí být předložen společnosti CFMOTO zákazníkem prostřednictvím místního distributora / prodejního partnera uvedeného ve smlouvě o prodeji vozidla.',
    bindingText16: '1.3.2.\tPokud to dostupné údaje umožňují, CFMOTO vyhodnotí údaje ve vztahu k příčině nehody a poskytne zákazníkovi odpovídající zprávu.',
    bindingText17: '1.4.\tPomoc Zákazníkovi získat Vozidlo po ztrátě Vozidla .',
    bindingText18: '1.4.1.\tV případě ztráty Vozidla poskytne CFMOTO Zákazníkovi na požádání a pokud jsou k dispozici údaje o poloze Vozidla a další užitečné údaje o stavu Vozidla (jako je poloha poslední aktivace, aktuální stav vozidla atd.).',
    bindingText19: '1.4.2.\tPožadavek musí být předložen společnosti CFMOTO zákazníkem prostřednictvím místního distributora / prodejního partnera uvedeného ve smlouvě o prodeji vozidla.',
    bindingText2:
      'Společnost CFMOTO Powersports, Inc. (dále jen „ CFMOTO “ ) poskytuje telematické služby vozidla zákazníkovi, který si zakoupil vozidlo CFMOTO (dále jen „Zákazník“ ). Pro tyto služby využívá CFMOTO údaje zaznamenané Vozidlem o Vozidle a jeho jízdním chování v příslušném časovém období. Konkrétně se to týká následujících údajů:',
    bindingText20: '1.5.\tHlášení poprodejních problémů .',
    bindingText21: '1.5.1.\tCFMOTO shromažďuje na dálku upozornění na chybové kódy zaslané Vozidlem v případě poruchy jeho součástí a poskytuje příslušné informace na žádost Zákazníka přímo Zákazníkovi.',
    bindingText22: '1.5.2.\tPožadavek musí být předložen společnosti CFMOTO zákazníkem prostřednictvím místního distributora / prodejního partnera uvedeného ve smlouvě o prodeji vozidla.',
    bindingText23: '2.\tOmezení a vyloučení služby',
    bindingText24: '2.1.\tVýslovně se poukazuje na to, že konstrukční nebo jiné technické změny na vozidle mohou omezit poskytování služeb nebo dokonce znemožnit, protože služby závisí na správném poskytnutí údajů o vozidle.',
    bindingText25: '2.2.\tV případě, že takové služby nemohou být poskytovány z důvodu výkonu jakýchkoli datových nebo telekomunikačních sítí třetích stran , je jakákoli odpovědnost společnosti CFMOTO vyloučena.',
    bindingText26: '3.\tSoukromí',
    bindingText27:
      'vozidlem CFMOTO dodržovat platné předpisy o ochraně osobních údajů . Podmínky zásad ochrany osobních údajů C FMOTO jsou uvedeny v této CFMOTO RIDE APP. Jako doplněk k zásadám ochrany osobních údajů je jeho oznámení v souladu se zásadami ochrany osobních údajů . Zákazník si může pro některý obsah související se zpracováním dat, na který se nevztahuje toto oznámení, podívat na zásady ochrany osobních údajů .',
    bindingText28: '4.\tSlužby zákazníkům',
    bindingText29:
      '4.1.\tZákazník může bez obav posílat otázky, komentáře nebo obavy týkající se ochrany osobních údajů na CFMOTORIDEAPP@cfmotousa.com nebo napsat na adresu: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. Zákazník může také zavolat CFMOTO Customer Relations na čísle (888) 823-6686. ',
    bindingText3: 'Údaje o chování uživatele při řízení : včetně zrychlení, zpomalení, rychlosti, zatáček, poslední doby jízdy a ujeté vzdálenosti .',
    bindingText30: '5.\tR revize',
    bindingText31: '5.1.\tCFMOTO si vyhrazuje právo toto upozornění kdykoli změnit, ale revize zveřejníme na CFMOTO RIDE Aplikujte a/nebo poskytněte upozornění, než tak učiníme podle potřeby.',
    bindingText4:
      'Údaje o stavu vozidla: označují stav vozidla v reálném čase, včetně jízdního režimu, zbytkového paliva, okamžité spotřeby paliva, ujetých kilometrů, rychlostního stupně vozidla v reálném čase, rychlosti motoru, tlaku v pneumatikách, teploty pneumatik, údajů o napětí aktivace baterie , teplota chladicí kapaliny, stav elektronického zámku, verze softwaru inteligentního zařízení, síla signálu chytrých zařízení, aktuální nastavení palubní desky.',
    bindingText5:
      'Data alarmu vozidla: data alarmu, která se mají odeslat, pokud určitá data překročí přednastavenou hodnotu, jako je teplota motoru, nadměrná rychlost, nadměrná doba jízdy, vysoká teplota chladicí kapaliny, abnormální pohyb vozidla, abnormální tlak v pneumatikách, vibrace, dumping, kolize atd . .',
    bindingText6: 'Informace o poruše vozidla: odkazuje na chybové kódy hlášené každou vnitřní částí vozidla.',
    bindingText7: 'Údaje o poloze vozidla: odkazují na konkrétní zeměpisné umístění vozidla.',
    bindingText8: '1.1.\tPoskytnutí ing Zákazník se službami souvisejícími s vozidlem prostřednictvím CFMOTO RIDE APP .',
    bindingText9: '1.1.1.\tSpotřebitelé mohou na dálku spravovat vozidla prostřednictvím CFMOTO RIDE APP (včetně zobrazení polohy vozidla, nastavení informací o vozidle a funkcí, dálkového ovládání stavu vozidla atd.).',
    bindingUser: 'Závazný uživatel',
    bound: 'Spárovaný',
    businessType: 'Typ podnikání',
    button: 'Tlačítko',
    callbackedApply: 'Stáhli jste žádost o smazání účtu dne yyyy-MM-dd HH:mm:ss',
    callbackedApplySyncTip:
      'Vaše žádost o odstranění účtu byla podána dne yyyy-MM-dd HH:mm:ss. Váš účet a související údaje budou trvale odstraněny 15 dní po obdržení vaší žádosti. Po vymazání již nebudete moci službu CFMOTO RIDESYNC používat. Chcete-li zrušit vymazání svého účtu, navštivte znovu webovou stránku nebo se do 15 dnů přihlaste do aplikace APP a stáhněte svou žádost o vymazání.',
    callbackedApplyTip:
      'Vaše žádost o odstranění účtu byla podána dne yyyy-MM-dd HH:mm:ss. Váš účet a související údaje budou trvale odstraněny 15 dní po obdržení vaší žádosti. Po vymazání již nebudete moci službu CFMOTO RIDE používat. Chcete-li zrušit vymazání svého účtu, navštivte znovu webovou stránku nebo se do 15 dnů přihlaste do aplikace APP a stáhněte svou žádost o vymazání.',
    cancel: 'Zrušit',
    cancellationAgreement: 'Storno smlouva',
    cancelled: 'Zrušeno',
    carOwner: 'Majitel',
    carUserScore: 'Hodnocení vlastníka vozidla',
    cardPass: 'Ověření totožnosti proběhlo úspěšně!',
    cfmotoName: 'CFMOTO',
    changeCodeValidate: 'Přepnutí na ověřování Captcha',
    changeDescriptionType: 'Změnit popis',
    changeDescriptionTypeSelectNo: 'Nezahrnuje změny předpisů o zpracování osobních údajů',
    changeDescriptionTypeSelectYes: 'Změny v předpisech týkajících se zpracování osobních údajů',
    changeEmailInfo: 'Přepnout na e-mail',
    changeFail: 'Změna stavu se nezdařila',
    changeOne: 'Změna',
    changePassValidate: 'Přepnutí na ověření heslem',
    changePasswordFailed: 'Změna hesla se nezdařila',
    changePasswordSuccessful: 'Změna hesla úspěšná',
    changePhoneInfo: 'Přepnout na telefonní číslo',
    changeStore: 'Změnit obchod',
    changeSuccess: 'Stav byl úspěšně upraven',
    channelType: 'kanál zpětné vazby',
    characterLimitExceeded: 'Je překročen limit počtu znaků',
    checkConfigurationTwo: 'Čínština nebo angličtina %s není plně nakonfigurována, zkontrolujte prosím',
    checkCopyWriting: 'Čínský nebo anglický obsah není vyplněn, zkontrolujte prosím',
    checkEmpty: '%s je prázdné, prosím zkontrolujte',
    checkTriggerType: 'Vyskytla se podmínka spouštěcího mechanismu, která nebyla vyplněna, zkontrolujte ji',
    checkUpdate: 'zkontrolujte aktualizace',
    cityFilter: 'Filtr města',
    clickImmediateFeedback: 'Kliknutím poskytněte zpětnou vazbu',
    clickNumber: 'Počet kliknutí',
    clickNumberDescription: 'Skutečný počet kliknutí uživatelů po úspěšném zobrazení oznamovací zprávy (kliknutí po 5 dnech nebudou započítána)',
    clickNumberVolume: 'Počet kliknutí',
    clickToFeedback: 'Klikněte na zpětnou vazbu',
    clicks: 'Kliknout',
    closeNum: 'uzavření',
    closeTask: 'Úkol zrušen',
    code: 'ověřovací kód',
    colorPicture: 'Obrázek barevného bloku',
    comment: 'Komentář',
    commentContent: 'Komentáře',
    commentList: 'Seznam recenzí',
    commentNumber: 'Počet komentářů',
    commentTime: 'Čas na komentář',
    communication: 'v komunikaci',
    community: 'Společenství',
    communityManagement: 'Komunitní management',
    communityRule: 'Pravidla komunity',
    completePuzzle: 'Doplňte prosím hádanku',
    completed: 'dokončeno',
    condition: 'stav',
    configureLanguage: 'Nakonfigurujte jazyk',
    configurePicture: 'Nakonfigurujte obrázek',
    confirm: 'Potvrdit',
    confirmDeletePictures: 'Potvrďte smazání tohoto obrázku',
    confirmReviewNoPass: 'Potvrdit, že přezkum neprošel',
    confirmReviewPass: 'Potvrdit, že přezkum proběhl úspěšně',
    consultDealer: 'Poraďte se s místním prodejcem',
    contact: 'Vaše žádost o smazání účtu byla zamítnuta. Máte-li jakékoli dotazy, kontaktujte prosím it@cfmoto.com pro konzultaci.',
    contactMail: 'E-mailová adresa',
    contactMethod: 'Kontakt',
    contactUs: 'Kontaktujte nás',
    content: 'Obsah',
    contentType: 'Typ obsahu',
    copyFail: 'Kopírování se nezdařilo',
    copyLink: 'Kopírovat odkaz',
    copySuccess: 'Replikace proběhla úspěšně',
    copyWriting: 'Vyskakovací obsah',
    country: 'Země/oblast',
    countryCode: 'Kód země',
    countryName: 'Země',
    countryNumber: 'Kód země',
    countryRegion: 'Země / Region',
    create: 'Nový přírůstek',
    createBy: 'Tvůrce',
    createStore: 'Vytvořit obchod',
    createTime: 'čas tvorby',
    cs_CZ: 'čeština',
    currency: {},
    currentConfig: {},
    currentCountryStoreTotal: 'Celkový počet obchodů v aktuální zemi',
    currentTime: 'Aktuální čas',
    customPage: 'Vlastní stránka',
    customSettings: 'Vlastní sloupce',
    dataDeletExplain: 'Průvodce odstraněním dat',
    dataDelete: 'Odstranění dat',
    dataDeleteApply: 'Žádost o vymazání dat',
    dataFormatError: 'Chyba formátu dat',
    dataPermissionScope: 'Rozsah oprávnění k datům',
    dataType: 'Typ dat',
    dayOne: 'dny jednou',
    days: 'den',
    daysAgo: 'před %s dny',
    de_DE: 'Němec',
    dealDate: 'Doba zpracování',
    dealerOperationList: 'Seznam operací prodejce',
    dealerOperationQuery: 'Dotaz na operace prodejce',
    dealerOperationRecord: 'Záznamy o operacích dealerů',
    dealerStore: 'Dealerské prodejny',
    dealerStoreImportTempateName: 'Šablona pro import poboček prodejců',
    dealerStoreQuery: 'Dotaz na prodejní sklady',
    dealers: 'Dovozce',
    default: 'Výchozí',
    defaultMap: 'Výchozí mapa',
    delete: 'Smazat',
    deleteAccountSYNCStep: 'O vymazání účtu CFMOTO RIDESYNC můžete požádat podle následujících kroků',
    deleteAccountStep: 'O vymazání účtu CFMOTO RIDE můžete požádat podle následujících kroků',
    deleteDataSYNCStep: 'O vymazání svých údajů z účtu CFMOTO RIDESYNC můžete požádat podle následujících kroků',
    deleteDataStep: 'O vymazání svých údajů z účtu CFMOTO RIDE můžete požádat podle následujících kroků',
    deleteFail: 'Smazání se nezdařilo',
    deleteFinish: 'Smazání dokončeno',
    deleteKolUserAuthentication: 'Smazat ověření uživatele KOL',
    deleteStore: 'Smazat obchod',
    deleteSuccess: 'Smazání proběhlo úspěšně',
    deleteTip: 'Opravdu chcete tento příspěvek smazat? Jakmile jsou informace odstraněny, nelze je obnovit',
    deleteVersionWarn: 'Zda odstranit tento záznam verze',
    deleteVideo: 'Smazat toto video?',
    detailAddress: 'Podrobná adresa',
    details: 'Podrobnosti',
    determine: 'Jistý',
    deviceCodeGet: 'Získejte kód zařízení:',
    deviceContent:
      'Kód zařízení přijímače elektronického ohradníku (dále jen: klíč) je řetězec 10místných kódů. Kód zařízení, QR kód a značka CE jsou vytištěny na stříbrné samolepicí PVC samolepce. Štítky jsou celkem tři, jeden je připevněn na karoserii vozidla (pro zobrazení musíte zvednout sedák); další dva jsou umístěny v tašce na příslušenství vozidla. (Doporučujeme, aby uživatelé nalepili štítek na příručku k vozidlu nebo na dálkové ovládání)\nStisknutím a podržením tlačítka ON otevřete klíč a vložte QR kód na zadní straně klíče do skenovacího rámečku',
    deviceNo: 'Číslo přiřazeného zařízení',
    deviceNumber: 'Číslo zařízení',
    deviceTitle: 'Kontrola kódu',
    digitalKey: 'digitální klíč',
    digitalKeyDesc: 'Není třeba nosit fyzický klíč, podporuje odemknutí vozidla po připojení přes APP Bluetooth (podporováno některými modely)',
    directRelease: 'Přímé publikování',
    disagree: 'Nesouhlasím',
    displayNumberDescription: 'Skutečný počet úspěšných zobrazení na terminálu zařízení po příchodu oznamovací zprávy (zobrazení po 5 dnech nebudou započítána).',
    displayNumberVolume: 'Počet zobrazení',
    displayOrder: {},
    displayPicture: {},
    donwloadTemplateDescription: {},
    download: 'Stáhnout',
    downloadFailFile: 'Stáhnout chybný soubor',
    downloadSuccessful: 'Stahování proběhlo úspěšně',
    downloadTemplate: 'Stáhnout šablonu',
    downloading: 'Stahování...',
    ebookChoice: {},
    ebookEmpty: {},
    ebookPlaceholder: {},
    ebookSwitch: {},
    ebookTitle: {},
    edit: 'Upravit',
    editAccountDeletExplain: 'Oznámení o odstranění účtu',
    editActivity: 'Úprava aktivity',
    editAppRating: 'Upravit mechanismus hodnocení',
    editBanner: 'Úprava banneru',
    editDataDeletExplain: 'Oznámení o odstranění údajů',
    editExhibitionCategory: {},
    editExhibitionSeries: {},
    editFunctionIntro: {},
    editInformation: 'Upravit informace',
    editInformationCategory: 'Upravit kategorii informací',
    editInformationContent: 'Upravit obsah informací',
    editKolUserAuthentication: 'Upravit ověření uživatele KOL',
    editModelSeries: 'Upravit modelovou řadu',
    editPicture: 'Upravit obrázek',
    editPushConfiguration: 'Upravit konfiguraci push',
    editRemark: 'Upravit poznámky',
    editServiceIntroduce: {},
    editShowroomModel: 'Upravit modely showroomů',
    editSuccess: 'Úspěšně upraveno',
    editTime: 'Upravit čas',
    editUnbindingCommitment: {},
    editUser: 'upravit uživatele',
    editVehicleModel: 'Upravit model',
    editVehicleModelCategory: 'Upravit kategorii vozidla',
    effecting: 'Čeká na aktivaci',
    effectiveTime: 'Datum účinnosti',
    electricVehicle: 'Elektrické vozidlo',
    email: 'E-mail',
    emailAdress: 'E-mailová adresa',
    emailAdressTip: 'Pozn:  Tato e-mailová adresa se používá pro kontakt se zákazníky prostřednictvím e-mailu.  Ujistěte se, že je e-mailová adresa správná',
    emailContent: 'Obsah emailu',
    emailImportTemplate: 'Šablona importu e-mailové adresy',
    emailImportTemplateToDownLoad: 'E-mailové adresy lze importovat hromadně, kliknutím stáhněte',
    emailList: 'Seznam e-mailů',
    emailManage: 'Správa e-mailů',
    emailMass: 'Email Blast',
    emailSearch: 'E-mailový dotaz',
    emailSendTip1: 'Note: Be sure to add the note in blue font below at the end of your email. If the text of your email is not in English, please translate it into the language you are using before adding it.',
    emailSendTip2: 'If you want to unsubscribe from such emails, go to the CFMOTO RIDE App, click the [Me] > [Settings] > [Message notification] to turn off the [Receive email marketing] function.',
    emailSendTip3: '*Emails without added notes will not be reviewed and approved.',
    emailText: 'E-mailem',
    emailTitle: 'Předmět',
    en_US: 'Angličtina',
    enableStatus: 'Stav povoleno',
    enabled: 'umožnit',
    endTime: 'Čas ukončení',
    endTimeLargeStartTime: 'Čas ukončení musí být pozdější než čas zahájení',
    enterAnswer: {},
    enterCategory: {},
    enterCodeToSafeAccount: 'Pro zajištění bezpečnosti potvrďte informace o svém účtu, který chcete odstranit, a zadejte heslo nebo ověřovací kód pro ověření totožnosti.',
    enterCodeToSafeData: 'Pro zajištění bezpečnosti potvrďte informace o svém účtu a zadejte heslo nebo ověřovací kód pro ověření vaší totožnosti.',
    enterIntroduceText: {},
    enterLink: {},
    enterPopupTitle: {},
    enterQueryConditionLookData: 'Po zadání podmínek dotazu si můžete data prohlédnout',
    enterQuestion: {},
    enterQuestionAndAnswer: {},
    enterSureUrl: {},
    enterTypeOfLanguage: {},
    enterUnbindingCommitment: {},
    entrance: {},
    errorLatAndLon: 'Zeměpisná šířka a délka jsou nesprávně naformátovány, zkontrolujte je prosím.',
    errorLocation: {},
    es_ES: 'španělština',
    estimatedTime: 'Předpokládaný čas',
    everySet: 'Podle nastavení',
    examineResultMessage: 'Aplikační materiály ověříme co nejdříve, věnujte prosím pozornost oznamovací liště nebo centru zpráv APP včas.',
    example: 'precedens',
    exhibition: {},
    exhibitionCategory: {},
    exhibitionCategoryList: {},
    exhibitionCategorySearch: {},
    exhibitionSeries: {},
    exhibitionSeriesList: {},
    exhibitionSeriesSearch: {},
    exportContent: 'Exportujte svůj obsah',
    exportExcel: 'Export do EXCELu',
    exportLengthExceedOfMonth: 'Délka vývozu nesmí překročit %s měsíců',
    externalLink: 'Externí odkaz',
    failed: 'Nepodařilo se',
    failedToPreview: 'Kontrola se nezdařila',
    feedBackResut: 'Výsledky zpětné vazby',
    feedBackTime: 'Čas pro zpětnou vazbu',
    feedBackVechle: 'Vozidlo',
    feedbackAppQuestion: 'Podrobně popište čas výskytu, verzi aplikace APP, model mobilního telefonu, způsob ovládání a popis problému, abyste mohli problém rychle lokalizovat a vyřešit!',
    feedbackDetails: 'Podrobnosti o zpětné vazbě',
    feedbackGuideDesc: 'Pro více informací nás prosím kontaktujte prostřednictvím kanálu zpětné vazby níže',
    feedbackLabelFileList: 'Nahrajte prosím obrázek',
    feedbackMapQuestion: {},
    feedbackMessageSubmitError: 'Zpětná vazba selhala',
    feedbackOtherQuestion: 'Popište prosím, kdy se to stalo, jak se to stalo a v čem je problém.',
    feedbackReceived: 'Obdržená zpětná vazba',
    feedbackRecord: 'Záznam o zpětné vazbě',
    feedbackRulesFileListMaxSize: 'Nahraný soubor je příliš velký',
    feedbackRulesFileListOverType: 'Nepodporovaný formát',
    feedbackSubmitTip: 'Máte-li jakékoli dotazy nebo připomínky, můžete také kontaktovat zákaznické centrum CFMOTO Mexico přímo přes WhatsApp (+52 18115286003) nebo e-mail (servicioalclient@cfmoto.com.mx)',
    feedbackSuggest: 'Vítejte na cenné návrhy, budeme vážně zvážit vaše nápady',
    feedbackSupplement: 'Přidejte prosím popis problému',
    feedbackText: 'Zpětná vazba',
    feedbackType: 'Typ zpětné vazby (jeden výběr)',
    feedbackVehicleQuestion: 'Popište prosím, kdy se to stalo, jak se to stalo a v čem je problém.',
    female: 'Žena',
    fileCountExceed: 'Počet souborů překračuje limit',
    fileSizeExceed: 'Velikost souboru překračuje limit',
    fileUploadingPleaceWait: 'Nahrávání souboru, čekejte prosím',
    finalOperator: {},
    firstMenu: 'Menu první úrovně',
    forcedUpgrade: 'Vynucená aktualizace',
    forgetPassword: 'Zapomenuté heslo',
    fourCarOfNumber: 'Počet uživatelů čtyřkolových vozidel',
    fourWheel: 'Čtyřkolové motocykly',
    fourWheelConfig: {},
    fourWheeler: 'Čtyřkolka',
    fourWheelerMostClicks: 'Modely čtyřkolových vozidel s největším počtem kliknutí',
    fourWheelowner: {},
    fr_FR: 'francouzština',
    frankfurt: 'Frankfurt',
    friday: 'Pátek',
    fuctionIntro: {},
    fullscreen: 'Celá obrazovka',
    funServiceIntro: {},
    function: 'Funkce',
    functionConfiguration: {},
    functionConfigureTip: 'Tato funkce je k dispozici pouze pro nakonfigurovaná vozidla pod jménem dovozce nebo uživatelským jménem v dané zemi',
    functionDescription: {},
    functionDetail: {},
    functionIntroduce: 'Popis funkce',
    functionSetting: {},
    functionalOverview: 'Přehled funkcí',
    galleryEntrance: 'Vstup do galerie',
    galleryEntranceUploadRules: 'Požadavky na formát: jpg/jpeg/png, doporučený poměr stran 4:3, velikost ne více než 5 MB',
    gender: 'Pohlaví',
    generalAlarm: 'Obecný poplach',
    geofence: 'Elektronický plot',
    getCarPosition: 'Získejte umístění vozidla včas',
    getCode: 'Poslat',
    goCustomPage: 'Přejít na vlastní stránku',
    goOffline: 'Offline',
    goOnline: 'Online',
    goUrlLink: 'Přejít na odkaz URL',
    groupTrail: {},
    groupTrailConfig: {},
    guest: 'Žádné auto',
    haveTwo: 'Obě',
    havedWrite: 'Vyplněny',
    havedWriteAll: '.',
    havedWriteAllOrEmpty: 'vyplněno nebo prázdné',
    helpAndFeedback: 'Nápověda a zpětná vazba',
    helpCenter: 'Centrum nápovědy',
    helpMessageHistoryDelete: 'Smazat všechny záznamy vyhledávání?',
    helpful: {},
    hint: 'Náznak',
    historyDelete: 'Smazat všechny záznamy vyhledávání?',
    home: 'Domovská stránka',
    homePage: 'Kişisel Ana Sayfa',
    hour: 'Hodina',
    hoursAgo: '%s hodinami před',
    iWantEnableStoreUserQuery: 'Chci aktivovat hledání uživatelů prodejen',
    iWantToPostStatistics: 'Chci zveřejnit statistiky',
    identification: 'Identifikace',
    identificationText: 'Identifikace',
    imageSizeExceed: 'Vă rugăm să încărcați o imagine cu o lățime și înălțime de %s',
    imageUploadFailed: 'Nahrání obrázku se nezdařilo',
    immediateSend: 'Odeslat nyní',
    imporFailedOfTableHeader: 'Import se nezdařil. Záhlaví souboru neodpovídá',
    import: 'import',
    importDetails: 'Podrobnosti otázky',
    importExcel: 'Importovat EXCEL',
    importFail: 'Import selhal',
    importStatus: 'Stav importu',
    importSuccessful: 'Import byl úspěšný',
    importTemplate: 'Import šablony ke stažení',
    importer: 'dovozce',
    importerAccountOperationRecord: 'Záznamy o operacích a přihlášení účtu importéra',
    importerAvatar: 'Avatar dovozce',
    importerDisplayName: 'Zobrazené jméno dovozce',
    importerEnquiry: 'Dotaz dovozce',
    importing: 'Importuje se...',
    inProcess: 'protiopatření',
    inProgress: 'probíhá',
    individualCenter: 'Individuální centrum',
    informationCategory: 'Informační kategorie',
    informationCategoryList: 'Seznam kategorií informací',
    informationCategoryQuery: 'Dotaz na kategorii informací',
    informationContent: 'Informační obsah',
    informationContentList: 'Seznam obsahu informací',
    informationCotnentQuery: 'Dotaz na informační obsah',
    informationCover: 'Informační obal',
    informationDetails: 'Podrobnosti o informacích',
    informationImage: 'titulní obrázek',
    informationManagement: 'Správa informací',
    informationTitle: 'Informační název',
    informer: 'Informátor',
    informerId: 'ID oznamovatele',
    initialPassword: 'Počáteční heslo',
    inputAgreementContent: 'Zadejte prosím obsah smlouvy',
    inputErrorEmoji: 'Nezadávejte prosím emotikony',
    installDeviceYouCan: 'Instalace tohoto zařízení vám umožní',
    installVehicleModelAdd: 'Přidat Popis doplněného modelu vozidla',
    installVehicleModelDescription: 'Popis doplněného modelu',
    installVehicleModelEdit: 'Upravit Popis doplněného modelu vozidla',
    instrumentLastedVersion: 'TFT displej není třeba upgradovat',
    instrumentupgrade: 'Upgrade TFT displeje',
    intelligentInternetServiceIntroduction: 'Zavedení služby',
    introText: {},
    introduction: 'Úvod',
    invalidVercode: 'neplatný ověřovací kód',
    iovNotice1: 'Výše uvedené funkce jsou založeny na síťovém zařízení vozidla (T-Box), nákup a instalaci konzultujte s místním prodejcem',
    iovNotice2: 'Výše uvedené funkce se liší podle konfigurace každého modelu a oblasti, kde se nachází. Podrobnosti najdete u místního prodejce.',
    iovNotice3: 'Předem si prosím uložte a zaznamenejte číslo zařízení, které je nutné při vázání zařízení. Po dokončení vazby a instalace můžete zažít další funkce',
    isHelpful: 'pomáhá to?',
    isStop: {},
    isSupportedChildOwnerOffMapDown: {},
    isSupportedNoOwnerOffMapDown: {},
    isSupportedOffMapDown: {},
    it_IT: 'italština',
    iterativeVehicleFunctions: 'Hlavní části vozidla lze upgradovat online na dálku, aby bylo možné nepřetržitě iterovat funkce vozidla',
    jumpSettings: 'Nastavení skoků',
    jumpTarget: {},
    jumpToWeb: {},
    jumpUrl: {},
    justNow: 'Právě teď',
    kolUserList: 'Seznam uživatelů KOL',
    kolUserManagement: 'Správa uživatelů KOL',
    kolUserQuery: 'Dotaz na uživatele KOL',
    language: 'Jazyk',
    language1: 'Příslušný jazyk',
    languages: 'Jazyk',
    lastLoginTime: 'Čas posledního přihlášení',
    lastModifiedBy: 'Naposledy upravil',
    lastUpdateTime: 'Čas poslední aktualizace',
    latitude: 'Zeměpisná šířka',
    launchActivity: 'Spuštění aktivity',
    likeNumber: 'Má rád',
    linkAddress: {},
    linkUrlDescription: {},
    listDisplayImages: 'Zobrazení seznamu',
    listOfImporters: 'Seznam dovozců',
    listOfQuestion: {},
    listShowStoreCoverPic: 'Seznam zobrazit obrázek obálky obchodu',
    loadSuccess: 'Načítání dokončeno',
    loading: 'načítání',
    locationFail: {},
    log: 'Log',
    login: 'Přihlásit se',
    loginCountry: 'Země/oblast přihlášení',
    logout: 'Odhlásit se',
    longitude: 'Zeměpisná délka',
    loosing: 'Osvěžující data...',
    lowCompatibleVersion: 'Minimální kompatibilní verze',
    mail: 'E-mail',
    male: 'Muž',
    manualReviewStatus: 'Stav ruční kontroly',
    mapManage: {},
    marketDataOfdealerStores: 'Tržní data obchodů dealerů',
    masteringCyclingData: 'Hlavní jízdní data',
    maximum: 'Max.',
    maximumBannerCountTip: 'Současně může být online maximálně %s bannerů.  Prosím, smažte nejprve alespoň jednu z nich.',
    maximumValue: 'Maksimum',
    menuFunctionName: 'Název funkce nabídky',
    menuIcon: 'Ikona nabídky',
    messagePush: 'Push zpráv',
    messagePushDeleteAsk: 'Jste si jisti, že chcete tento push smazat?',
    messagePushDownloadTemplate: 'Nejprve si stáhněte šablonu a po jejím vyplnění souboru šablony ji nahrajte. Velikost souboru je omezena na 2M. Pokud se odeslání nezdaří, prosíme, snižte přiměřeně obsah',
    messageWithdrawAsk: 'Chceš stáhnout tento push?',
    middle: 'střední',
    min: 'Min',
    minAgo: '%s minut před',
    minimum: 'Min.',
    minimumValue: 'Minimum',
    modelDetail: 'Detaily modelu',
    modifyFail: 'Úprava se nezdařila',
    modifyPassword: 'Upravit heslo',
    modifySuccess: 'Úprava úspěšná',
    monday: 'Pondělí',
    more4pic1video: 'Maximálně 4 obrázky / 1 video',
    morning: 'Ráno',
    motorcycle: 'dvoukolka',
    moveDown: 'Přesunout dolů',
    moveLongPressMap: {},
    moveMapSelectPoint: {},
    moveTo: 'Přesunout do',
    moveToBottom: 'Přesuňte se na dno',
    moveToTop: 'Přesuňte se na začátek',
    moveToTopStatus: 'Připnutí příspěvku',
    moveTop: 'Nejvyšší nastavení',
    moveUp: 'Povýšit',
    multimedia: 'Multimédia',
    mustInteger: {},
    mute1Day: 'Ticho na 1 den',
    mute2Days: 'Ticho na 2 dny',
    mute30Days: 'Ticho na 30 dní',
    mute3Days: 'Ticho na 3 dny',
    mute7Days: 'Ticho na 7 dní',
    muting: 'Ztlumit',
    nameOfImporter: 'Název dovozce',
    navigation: 'Navigace na mapě',
    nearLoginTime: 'Poslední čas přihlášení',
    needPopup: 'Potřebujete vyskakovací okno',
    negativeNum: 'Špatná recenze',
    networkException: 'Výjimka sítě',
    newAddFail: 'Přidání se nezdařilo',
    newAddSuccess: 'úspěšně přidáno',
    newBanner: 'Nové bannery',
    newCancellationAgreement: 'Nová smlouva o zrušení',
    newFunctionIntro: {},
    newMenuFunction: 'Nová funkce menu',
    newModelSeries: 'Nová modelová řada',
    newPassword: 'Nové heslo',
    newPasswordNotEqual: 'Dvakrát zadané nové heslo je nekonzistentní, zadejte jej prosím znovu',
    newQuestionType: {},
    newStoreNumber: 'Počet nových obchodů',
    newTopic: 'Nové téma',
    newUnbindingCommitment: {},
    nextStep: 'další',
    nickName: 'Přezdívka',
    no: 'Ne',
    noContent: 'Žádný související obsah',
    noContent2: 'Navrhněte změnu klíčových slov popř',
    noData: 'Žádná data',
    noFeedbackRecord: 'V současné době nejsou k dispozici žádné záznamy o zpětné vazbě.',
    noJump: 'Žádný skok',
    noLog: 'Žádný protokol',
    noNeedPopup: 'Nejsou vyžadována žádná vyskakovací okna',
    noOkToFeedback: 'Nevyřešeno, chci dát zpětnou vazbu',
    noOwnerScore: 'Hodnocení nevlastníka',
    noPass: 'Selhání',
    noSendPeople: 'Žádný odesílatel',
    noSupportMapDown: {},
    noThisPermission: 'Žádné povolení pro tuto operaci',
    noUserSelected: 'Nebyl vybrán žádný uživatel, nelze odeslat',
    nofiledSeviceContent: {},
    nonOwner: 'Nevlastník',
    nonVehicleOwnerCharged: {},
    none: 'Žádný',
    normal: 'Normální',
    notAllowImageAndVideo: 'Při výběru obrázků nelze vybrat video',
    notAllowed: 'Není povoleno',
    notBeLessOrEqual: 'nesmí být nižší nebo rovna',
    notDeleted: 'Nebylo odhlášeno',
    notDistributedYet: 'Ještě nevydáno',
    notEnabled: 'Není povoleno',
    notHelpful: {},
    notLessThan: 'Daha az olmamalıdır',
    notRecommended: 'Nedoporučuje se',
    notReleasedYet: 'Dosud nebyl vydán',
    notStarted: {},
    notTop: 'Nedosáhl jsem vrcholu',
    notice: 'Oznámení',
    noticeText1: 'Dear CFMOTO users,',
    noticeText2:
      'Hello! We sincerely thank you for your continuous support and trust in CFMOTO. We are committed to enhancing service quality and implementing innovative improvements, and we have made business adjustments due to this commitment. As of 08/10/2024, we will discontinue the CFMOTO RIDE App (the "App") in the United States. In its place, we have launched the brand-new CFMOTO RIDESYNC App. We hope you continue to enjoy our services through this new app.',
    noticeText3: 'Important notes:',
    noticeText4: '1. From today on, this app will only be available for bound CFMOTO vehicles in the United States and no longer support binding new vehicles. If you need to bind a new vehicle, please download and use the CFMOTO RIDESYNC App.',
    noticeText5:
      '2. We strongly recommend that you download and use the CFMOTO RIDESYNC App before 08/10/2024 so that you can continue enjoying our services seamlessly. We provide you with a convenient data migration service. You can choose to migrate all data retained in this App to the CFMOTO RIDESYNC App to preserve your personal information, vehicle information and past service records. We will ensure your data security and privacy during the migration process. If you want to use the CFMOTO RIDESYNC App without migrating data, you can re-register with the CFMOTO RIDESYNC App to use the new services. Click on the button below to learn how to download and use the CFMOTO RIDESYNC App.',
    noticeText6:
      '3. Please note that after 08/10/2024, you will no longer be able to use the relevant services of the App in the United States. Meanwhile, we will delete all personal data generated during your use of the App according to the relevant laws and regulations.',
    noticeText7:
      'We are fully aware that this change may cause temporary inconvenience to you, but we believe that with this service upgrade, you will have a richer and more satisfying user experience. If you encounter any issues or have questions during this process, we will always be here to help. Thank you for your understanding and cooperation, and we look forward to serving you in the CFMOTO RIDESYNC App.',
    noticeText8: 'Wish you a happy life!',
    notzero: 'Čísla verzí nemohou být všechna 0',
    offline: 'Offline',
    offlineAlready: 'Off-line',
    offlineTime: 'Čas offline',
    offlineTimeMustBeGreaterThan: 'Čas offline musí být větší než',
    ok: 'OK',
    oldPassword: 'staré heslo',
    onLineAlready: {},
    oneMonths: 'Jeden měsíc',
    oneYear: 'Jeden rok',
    online: 'On-line',
    onlyFourWheel: 'Pouze čtyřkolové',
    onlyTwoWheel: 'Pouze dvoukolové',
    openEveryCount: {},
    openEveryDay: {},
    openProductType: {},
    operationRecord: 'Záznam provozu',
    operationTime: 'Čas provozu',
    operations: 'Operace',
    operator: 'Operátor',
    opreate: {},
    opreateFunSet: {},
    opreateFunSetAdvert: {},
    opreateFunSetAdvertAdd: {},
    opreateFunSetAdvertEdit: {},
    opreateFunSetAdvertView: {},
    optionalUpgrade: 'Volitelná aktualizace',
    orderList: {},
    orderMange: {},
    orderNum: {},
    otaUpgradeVehicle: 'OTA upgrade vozidla',
    otaUpgradeVehicleDesc: 'Hlavní součásti vozidla lze upgradovat na dálku, aby se výkon vozidla neustále opakoval.',
    other: 'Jiný',
    over: 'přes',
    owner: 'Vezmi si auto',
    ownerIdHomepageImage: 'Hlavní stránka průkazu totožnosti, řidičského průkazu nebo pasu obsahující osobní identifikační informace.',
    parameterConfiguration: 'Konfigurace parametrů',
    partialImportFailed: 'Částečný import selhal',
    pass: 'Projít',
    passValidateDeleteAccount: 'Ověření totožnosti proběhlo úspěšně! Kliknutím na tlačítko Odeslat žádost v dolní části požádejte o odstranění účtu',
    password: 'Heslo',
    passwordRuleText: '8-20 znaků, musí obsahovat velká a malá anglická písmena, číslice, speciální znaky',
    passwordRules: 'Pravidla hesla',
    paySetting: {},
    payStrategy: {},
    peleaseEnterProvince: 'Zadejte prosím provincii/stát',
    pendSend: 'čekající',
    pending: 'Čekající.',
    permanentMuting: 'Ztlumeno trvale',
    phoneModel: 'Číslo modelu',
    phoneNum: 'telefonní číslo',
    phoneNumber: 'Telefonní číslo',
    phoneOrEmail: 'Telefonní číslo/e-mail',
    phoneOrEmailImportTemplate: 'Šablona pro import čísla mobilního telefonu/e-mailové adresy',
    phoneOrEmailNotRegistered: 'Bu cep telefonu numarası veya e-posta adresi kayıtlı değil',
    phoneOrEmailOrUserId: 'Telefonní číslo/e-mailová adresa/uživatelské ID',
    picture: 'Obrázek',
    pl_PL: 'polština',
    pleaseAddImage: 'Přidejte soubory obrázků',
    pleaseAddVideoFile: 'Přidejte video soubory',
    pleaseEnter: 'Zadejte prosím',
    pleaseEnterAccountInfo: 'Zadejte informace o účtu',
    pleaseEnterAmount: {},
    pleaseEnterCity: 'Zadejte prosím město',
    pleaseEnterEmail: 'prosím zadejte svou e-mailovou adresu',
    pleaseEnterEmailAdress: 'Zadejte e-mailovou adresu',
    pleaseEnterIntro: 'Zadejte prosím úvod',
    pleaseEnterLatAndLong: 'Zadejte prosím zeměpisnou šířku a délku',
    pleaseEnterNewPassword: 'Zadejte nové heslo',
    pleaseEnterPassword: 'Zadejte heslo',
    pleaseEnterPhone: 'Zadejte prosím své telefonní číslo',
    pleaseEnterQuestionDescription: 'Zadejte prosím popis svého problému',
    pleaseEnterRealname: 'Zadejte prosím své skutečné jméno',
    pleaseEnterRemark: 'Zadejte poznámky',
    pleaseEnterServePhone: 'Zadejte prosím telefonní číslo služby',
    pleaseEnterStoreAddressDetail: 'Zadejte prosím podrobnou adresu',
    pleaseEnterStoreIntroduce: 'Zadejte prosím představení obchodu',
    pleaseEnterStoreName: 'Zadejte prosím název obchodu',
    pleaseEnterStoreRemarkName: 'Zadejte prosím název poznámky k obchodu',
    pleaseEnterTitle: 'Zadejte název',
    pleaseEnterUsername: 'Zadejte uživatelské jméno',
    pleaseEnterVercode: 'Zadejte vercode',
    pleaseEnterVersion: 'Zadejte číslo verze',
    pleaseEnterVersionIntroduction: 'Zadejte úvod verze',
    pleaseEnterVideoDetail: 'Zadejte podrobnosti o videu',
    pleaseEnterVin: 'Zadejte prosím VIN',
    pleaseInputWord: 'Zadejte klíčové slovo',
    pleaseLoginFirst: 'Prosím nejdříve se přihlašte',
    pleaseRepeatNewPassword: 'prosím zopakujte nové heslo',
    pleaseSelect: 'prosím vyber si',
    pleaseSelectBusinessHours: 'Vyberte prosím otevírací dobu',
    pleaseSelectCity: 'Vyberte prosím město',
    pleaseSelectCountry: 'Vyberte prosím zemi',
    pleaseSelectCurrency: {},
    pleaseSelectMatchingMultimediaContent: 'Vyberte prosím odpovídající multimediální obsah',
    pleaseSelectPayChannel: {},
    pleaseSelectProblemWhere: 'Vyberte prosím scénář, ve kterém se problém vyskytuje',
    pleaseSelectProducType: {},
    pleaseSelectProvince: 'Vyberte prosím provincii/stát',
    pleaseSelectQueType: 'Vyberte typ otázky',
    pleaseSelectReportReason: 'Vyberte, prosím, důvod hlášení',
    pleaseSelectStatus: 'Vyberte prosím stav',
    pleaseSelectStoreType: 'Vyberte prosím typ prodejny',
    pleaseSelectTimedSendTime: 'Vyberte prosím čas odeslání',
    pleaseSelectUserTheList: 'Vyberte prosím uživatele ze seznamu',
    pleaseSelectVehicle: 'Vyberte prosím vozidlo',
    pleaseSelectVehicleConfig: {},
    pleaseSelectupgradeType: 'Vyberte prosím způsob aktualizace',
    pleaseSureType2: 'Ujistěte se, že je vše v',
    pleaseUpload: 'Nahrajte prosím',
    pleaseUploadPicVideo: 'Nahrajte prosím obrázky/videa',
    popUpFrequencyType: 'Formulář vyskakovacího okna',
    popUpFrequencyValue: 'Frekvence vyskakovacích oken',
    popUpFrequencyValueValid: 'Vyberte dny frekvence',
    popUpReminder: 'Zda se má zobrazit připomenutí',
    popupArea: 'vyskakovací rozsah uživatelů',
    popupCreate: {},
    popupDayOne: 'Jednou za stanovený počet dní',
    popupEdit: {},
    popupFrequency: {},
    popupManagement: {},
    popupOne: {},
    popupPosition: {},
    popupStatus: {},
    popupTarget: {},
    popupTime: {},
    popupTitle: {},
    positiveNum: 'Dobré recenze',
    postComment: 'Zanechat komentář',
    postContent: 'Obsah příspěvku',
    postId: 'ID příspěvku',
    postList: 'Seznam příspěvků',
    postManagement: 'Správa příspěvků',
    postSearch: 'Hledání pošta',
    posts: 'Odesílá',
    precautionText1:
      'Hello! As you have learned that we will discontinue the CFMOTO RIDE App (hereinafter referred to as "the App") in the United States from 08/10/2024, to assist you with this change, please take note of the following important matters:',
    precautionText2: '1. From today on, you will not be able to bind a new vehicle through the APP to enjoy relevant vehicle services.',
    precautionText3: '2. To ensure a smooth transition to the new service, we have provided an entry at the top of the vehicle page in this App. You can learn how to download and use the CFMOTO RIDESYNC App at any time through that entry.',
    precautionText4:
      '3. Please note that once the service ceases to take effect, you will no longer be able to enjoy any services of the App in the United States. At the same time, we will delete all personal data generated during your use of the App in accordance with relevant laws and regulations. This means that we will not be able to respond to any of your requests for data after the service is discontinued.',
    precautionText5:
      'We understand that this change may cause inconvenience to you, but we are committed to continuously protecting your data security and privacy. We encourage you to take early action to download and start using the CFMOTO RIDESYNC App in a timely manner so that you can continue to enjoy the quality service provided by CFMOTO. If you have any questions or need assistance in this process, please do not hesitate to contact us. We look forward to serving you in the CFMOTO RIDESYNC App.',
    privacyContent: 'Podrobnosti o obsahu zásad ochrany osobních údajů',
    privacyPolicy: 'Zásady ochrany osobních údajů',
    privacyPopupAgree: 'Prostřednictvím vyskakovacího okna znovu získejte souhlas uživatele se zásadami ochrany osobních údajů',
    privacyVersion: 'Verze zásad ochrany osobních údajů',
    privacyVersionList: 'Seznam verzí zásad ochrany osobních údajů',
    problemaDes: 'Problém Popis',
    processMethod: 'Metody zpracování',
    processReason: 'Důvod zpracování',
    processReasonDetails: 'Podrobnosti o důvodu zpracování',
    processRecord: 'Zpracování záznamů',
    processReport: 'Zpracování sestav',
    processSolution: 'Řešení pro obrábění',
    processUser: 'Manipulace s uživateli',
    processed: 'Zpracované',
    productDetails: {},
    productTime: 'doba výroby',
    prohibitDecimalsAndNegative: {},
    pt_PT: 'portugalština',
    publishInformation: 'Publikovat informace',
    publishPosts: 'Zveřejnění příspěvku',
    pullBefore: 'Stáhněte dolů a osvěžte se.',
    pulling: 'Vydejte aktualizaci hned',
    purchaseAndInstall: 'Koupit a nainstalovat',
    pushConfiguration: 'Konfigurace Push',
    pushContent: 'Push obsah',
    pushList: 'Seznam Push',
    pushMode: 'Režim push',
    pushNow: 'Push nyní',
    pushQuery: 'Push Dotaz',
    pushRecord: 'Záznam Push',
    pushScope: 'Rozsah push',
    pushTime: 'Čas push',
    pushTimeDifferenceAsk: 'Čas odeslání, který zvolíte, může způsobit, že někteří uživatelé nebudou moci tento push přijmout kvůli časovým rozdílům. Opravdu chcete uložit?',
    pushTitle: 'Záhlaví Push',
    pushed: 'Zatlačeno',
    pushing: 'Probíhající push',
    query: 'Hledání',
    question: {},
    questionInquiry: {},
    questionType: 'Typ otázky',
    questionTypeList: {},
    questionTypeTemplate: {},
    quickRelease: 'Rychlé uvolnění',
    ranking: 'Žebříček',
    ratingWarn1: 'Pro uživatele vlastníků vozidla nebylo na pozadí správy zapnuto ovládání chytré služby odpovídající zemi/oblasti nebo po zapnutí nevypršela platnost služby chytré služby. Vozidlo je online a má',
    ratingWarn2: 'nebo více úplných záznamů o jízdě (začátek a konec každé jízdy je hlášena událost), vyskakovací okno se objeví, když uživatel opustí Moje cyklistika a vrátí se na domovskou stránku.',
    reUpgrade: 'Zkuste to znovu',
    readAgree: 'Přečtěte si a odsouhlaste',
    readAndAgree: 'Prosím, přečtěte si a souhlaste',
    readAndAgreeTo: 'Přečetl jsem a souhlasím s',
    readDeleteStep: 'porozumět typům údajů, které vymažeme nebo uchováme, a případným dalším lhůtám uchovávání',
    realname: 'Skutečné jméno',
    reasonForReport: 'Důvod',
    receiveCarReminderMessage: 'Přijímejte upozornění na zprávy o vozidle',
    rechargeAmount: {},
    rechargeChannel: {},
    rechargeStatus: {},
    rechargeTime: {},
    recharged: {},
    recipients: 'Příjemce',
    recipientsNum: 'Rozsah příjemce',
    recommended: 'Doporučovat',
    recommendedStatus: 'Doporučený stav',
    redirectUrl: {},
    refreshInterval: 'Interval obnovení',
    refreshSend: 'přeposlat',
    refundFailed: {},
    refunded: {},
    refunding: {},
    refused: 'Odmítnuto',
    registerDate: 'Čas registrace',
    rejected: 'Odmítnuto',
    releaseContent: 'Publikování obsahu',
    releaseMute: 'Osvoboďte ticho',
    releaseTime: 'Čas vydání:',
    released: 'Uvolnit',
    releasedBy: 'Vydavatel',
    remark: 'Poznámky',
    rememberPassword: 'Pamatovat heslo',
    reminder: 'Připomínka',
    remove: 'Vymazat',
    removeOnlinUpgrade: 'Vzdálené online upgradovací vozidlo',
    repeatNewPassword: 'Opakujte nové heslo',
    replaceTBOX: 'Výměna TBOXu',
    replied: 'Odpověděl',
    reply: 'Odpovědět',
    report: 'Nahlásit',
    reportList: 'Seznam hlášení',
    reportManagement: 'Správa sestav',
    reportReason: 'Důvod nahlášení',
    reportReasonDetails: 'Podrobnosti o důvodu oznámení',
    reportReasonPlaceholder: 'Napište, o čem chcete informovat, 0-1500 slov',
    reportSearch: 'Vyhledávání v sestavě',
    reportSuccessful: 'Nahlásit úspěšně, budeme se tím zabývat co nejdříve',
    reportTime: 'Čas hlášení',
    reportType: 'Typ zprávy',
    reportedContent: 'Obsah zprávy',
    reportedUser: 'Nahlášení uživatele',
    reportedUserId: 'ID uživatele sestavy',
    requestTimedOut: 'Vypršel časový limit žádosti',
    reset: 'Obnovení',
    return: 'Vrátit se',
    review: 'Posouzení',
    reviewApproved: 'Recenze prošla',
    richText: {},
    ro_RO: 'rumunština',
    roleDescription: 'Popis role',
    roleName: 'Název role',
    rolePermission: 'Povolení role',
    'routerTitleBinding-agreement': '绑车协议',
    routerTitleDownload: 'CFMOTO RIDE APP Download',
    routerTitleEbook: 'ebook',
    routerTitleIntroduce: '介绍',
    routerTitleOrderConfirm: 'Order Confirmation',
    routerTitlePdf: 'PDF',
    ru_RU: 'ruština',
    safeRemind: 'Z důvodu ochrany vašeho účtu zde prosím nezadávejte citlivé osobní údaje, jako jsou hesla k účtům apod.',
    satelliteMap: 'Satelitní mapa',
    saturday: 'Sobota',
    save: 'Uložit',
    saveAndPreview: 'Uložit a zobrazit náhled',
    saveFail: 'Nepodařilo se uložit',
    savePicture: 'Uložit obrázek',
    saveSettings: 'Uložit nastavení',
    saveSuccess: 'Úspěšně uloženo',
    saveVideo: 'Uložit video',
    scanQrcodePreview: 'Pro zobrazení náhledu naskenujte pomocí mobilního telefonu níže uvedený QR kód',
    screenNavigationGuidance: 'Pokyny k nastavení',
    sdkStatement: 'prohlášení SDK',
    search: 'Vyhledávání',
    searchRecords: 'Historické vyhledávání',
    secondaryMenu: 'Sekundární menu',
    securityMessage: 'Výše uvedené informace slouží pouze k ověření identity, CFMOTO chrání vaše informace.',
    select: 'Vyberte',
    selectAll: 'Vybrat vše',
    selectAuthentication: 'Vybrat ověření',
    selectChannelType: 'Vyberte prosím kanál zpětné vazby',
    selectCountry: 'Zvolte zemi',
    selectData: 'Vyberte údaje, které chcete odstranit, a kliknutím na tlačítko Odeslat v dolní části odešlete žádost o odstranění údajů.',
    selectDate: 'Vyberte Datum',
    selectEnableStatus: {},
    selectFeedBackState: 'Vyberte stav zpracování zpětné vazby',
    selectFeedbackType: 'Vyberte typ zpětné vazby',
    selectJumpTarget: {},
    selectLanguage: 'Vyberte jazyk',
    selectOneCarType: 'Vyberte alespoň jeden model',
    selectPoint: {},
    selectPopupFrequency: {},
    selectPopupPosition: {},
    selectPopupTarget: {},
    selectPopupTime: {},
    selectRejectReason: 'Vyberte prosím důvod zamítnutí',
    selectTheLanguage: 'Vyberte jazyk',
    selectTime: 'vyberte čas',
    selectUser: 'Vyberte uživatele',
    selectVehicle: 'Vyberte vozidlo',
    selectionOfImporter: 'Výběr importéra',
    sendNumberDescription: 'Mezi efektivními cílovými zařízeními server Aurora skutečně úspěšně vytvoří počet zařízení pro odeslání úlohy',
    sendNumberVolume: 'Počet odeslání',
    sendType: 'Režim odesílání',
    sendUserNum: 'Počet odeslání',
    sending: 'Při odesílání',
    serial: 'Ne.',
    seriesBackground: {},
    seriesDesc: {},
    seriesIntroduction: 'Úvod řady',
    seriesName: {},
    seriesShowcase: 'Přehlídka řady',
    seriesUplodImgRule: {},
    seriousAlarm: 'Vážný poplach',
    serviceIntroduction: 'Zavedení služby',
    serviceText: 'Služba',
    settingSuccess: 'Úspěšně nastaveno',
    shareNumber: 'Počet pramenů',
    sheet: 'Zhang',
    show: 'Pohled',
    showPicturesOfVideos: 'Zobrazit obrázky/videa',
    showroomModel: 'Modely showroomů',
    showroomModelList: 'Seznam modelů showroomu',
    showroomModelQuery: 'Dotaz na model showroomu',
    showroomUploadRules: 'Požadavek na formát obrázku je jpg/jpeg/png, poměr obrázku je 9:19,5, velikost nepřesahuje 5 MB a velikost videa nepřesahuje 50 MB',
    signOut: 'Automaticky ukončeno',
    singapore: 'Singapur',
    sixMonths: 'Šest měsíců',
    slideToRight: 'přejeďte doprava',
    smartServices: 'Chytré služby',
    someUser: 'Někteří uživatelé',
    sort: 'Třídit',
    source: 'Zdroj dat',
    sr_YU: 'srbština',
    startChecking: 'Začít kontrolovat',
    startTime: 'Čas zahájení',
    statisticalTime: 'Statistický čas',
    status: 'Stav',
    stepText1: 'To ensure smooth data migration and use of the CFMOTO RIDESYNC App, we recommend that you follow these steps:',
    stepText2: '1. First, you can click the button below [Download CFMOTO RIDESYNC] or directly open Apple Store/Google Play to search and download CFMOTO RIDESYNC App;',
    stepText3: '2. After downloading and installing, please open the CFMOTO RIDESYNC App to enter the login page. On this page, you need to log in with your existing CFMOTO RIDE account and password;',
    stepText4:
      '3. When you enter your account and password correctly, the App will pop up a prompt window asking whether to start the data migration. When you click OK, the data migration starts immediately and this process is uninterrupted. If you select "Cancel" in this step, you will not be able to continue logging into the App.',
    stepText5: '4. After clicking OK, the data migration will start immediately, and the process is uninterruptable. If that fails, contact it@cfmoto.com',
    stepText6:
      '5. After the data migration is completed, you will automatically enter the vehicle homepage of the CFMOTO RIDESYNC App. At this moment, you can start to use all functions of the App normally, and you will be able to access all the data you previously retained in the CFMOTO RIDE App.',
    stepText7:
      '*Important notes: Be sure to log in the CFMOTO RIDESYNC App with your CFMOTO RIDE account to ensure successful data migration. If you choose to register a new account or log in with another account, your data will not be migrated. In addition, after successful data migration, your original CFMOTO RIDE account will no longer support login to the CFMOTO RIDE App. Please operate carefully to ensure the safe migration of your data.',
    stop: {},
    store: {},
    storeAddressCountryTip: 'Pozn:  Tato adresa obchodu je jediným základem, na kterém vás uživatelé mohou najít.  Vyplňte prosím pečlivě a ujistěte se, že je adresa správná',
    storeAddressDetail: 'Adresa obchodu',
    storeAddressDetailTip: 'Příklad: podrobná adresa:  NO.116, Wuzhou Road, Yuhang Economic Development Zone, Hangzhou',
    storeAddressPosition: 'Zeměpisná šířka a délka',
    storeAddressPositionTip:
      'Zeměpisná délka: celočíselná část zeměpisné délky je celé číslo od -180 do 180 a desetinná část je desetinné číslo nepřesahující 15 číslic.\nZeměpisná šířka: celočíselná část zeměpisné šířky je celé číslo od -90 do 90 a desetinná část je nejvýše 15 desetinných míst.',
    storeBusinessType: 'Typ obchodu',
    storeImage: 'Obrázek obchodu',
    storeImportTemplateText: 'Stáhněte si prosím šablonu, vyplňte informace o obchodě prodejce v souboru šablony a poté nahrajte soubor; velikost souboru je omezena na 1 MB; pokud odeslání selže, snižte obsah nebo nahrávejte po částech',
    storeIntroduce: 'Zavedení obchodu',
    storeList: 'Seznam obchodů',
    storeMange: 'Vedení prodejny',
    storeName: 'Název obchodu',
    storeNameTip: 'Pozn: Pro vyplnění názvu obchodu vyberte jazyk podporovaný systémem',
    storeQueryUserStatistics: 'Statistiky uživatelů podle dotazu na obchod',
    storeRemarkName: 'Název poznámky k úložišti',
    storeRemarkNameTip: 'Pozn: Pokud jazyky podporované systémem nevyhovují vašim potřebám, můžete zde zadat název poznámky k obchodu v jazyce, který chcete.',
    storeSearch: 'Dotaz na úložiště',
    storeServicePhone: 'Telefonní číslo služby',
    storeServicePhoneTip: 'Pozn: Toto číslo je pro telefonní kontakt zákazníka, ujistěte se prosím, že je telefonní číslo správné.',
    storeServiceTime: 'Doba otevření',
    storeStatistics: 'Statistiky prodejen',
    storeUploadImageRequire: 'Požadavky na formát obrázku jpg/jpeg/png, doporučuje se, aby velikost jednoho obrázku nepřesáhla 5 MB, jeden import až 9, lze importovat více než jednou, celkový počet ne více než 9.',
    storefront: 'Obchod',
    submissionFailed: 'Odeslání se nezdařilo, zkuste to prosím znovu.',
    submit: 'Potvrdit',
    submitAccountDeleteApply: 'Odeslání žádosti o odstranění účtu',
    submitDataDeleteApply: 'Podat žádost o vymazání údajů',
    submitFeedback: 'Odeslat zpětnou vazbu',
    submitted: 'Předloženo',
    successful: 'Úspěšný',
    sunday: 'Neděle',
    supportMapDown: {},
    supportedChannel: {},
    sureAgree: 'Souhlasíte, nebo ne?',
    sureBackApply: 'Potvrďte stažení žádosti o smazání účtu',
    sureDelete: 'Jakmile je smazán, nelze jej obnovit. Opravdu jej chcete smazat',
    sureDeleteData: 'Jste si jisti, že chcete odstranit vybrané údaje? Po potvrzení budou data okamžitě odstraněna a nebude možné je obnovit',
    sureDeleteSeries: {},
    sureDeleteSetting: {},
    sureDeleteStoreInfo: 'Potvrzení vymazání informací o tomto obchodě? Po smazání nebude možné informace obnovit.',
    sureReject: 'Jste si jisti, že odmítnete?',
    sureSuspend: 'Odesílání se po ukončení zastaví. Opravdu chcete ukončit',
    suspend: 'Vypovědět',
    sv_SE: 'švédský',
    switchLanguage: 'Přepněte jazyk',
    system: 'Systém',
    systemBusy: 'Systém je zaneprázdněn, zkuste to znovu později',
    systemVersion: 'verzi systému',
    tboxIntro: 'T-Box je klíčové zařízení pro realizaci funkce inteligentního síťového připojení vozidel',
    teamConfigTip: {},
    threeMonths: 'Tři měsíce',
    thursday: 'Čtvrtek',
    time: 'Čas',
    timeSend: 'Časované odeslání',
    timedOffline: 'Naplánováno offline',
    timedPush: 'Časované push',
    timedRelease: 'Časované vydání',
    timedSendTime: 'Pošlete čas',
    tips: 'Tipy',
    title: 'titul',
    to: 'Do',
    toBeReleased: 'Již brzy',
    topMenu: 'Horní menu',
    topicContent: 'Obsah tématu',
    topicList: 'Seznam témat',
    topicManagement: 'Správa témat',
    topicSearch: 'Vyhledávání témat',
    topicTitle: 'Název tématu',
    totalAndlLayoutOfStores: 'Celkový počet a rozložení obchodů',
    totalClicks: {},
    totalNumber: 'Celkový počet',
    tr_TR: 'turečtina',
    triggerNum: 'Počet spouštěčů',
    tuesday: 'Úterý',
    turnOn: 'Otevřít',
    twoCarAndFourCarOfNumber: 'Počet uživatelů dvou- a čtyřkolových vozidel',
    twoCarOfNumber: 'Počet uživatelů dvoukolových vozidel',
    twoWheelConfig: {},
    twoWheeler: 'Dvoukolový',
    twoWheelerAndFourWheeler: 'Dvoukolová a čtyřkolová vozidla',
    twoWheelerMostClicks: 'Modely dvoukolových vozidel s největším počtem kliknutí',
    twoWheelowner: {},
    typeMessage: 'typ zpětné vazby',
    types: 'Typ',
    unbind: 'Nespárovaný',
    unbindingCommitment: {},
    unbindingLabelRealName: 'Vaše celé jméno',
    unbound: 'Bez závazků',
    understandRealtimeConditions: 'Přijímejte zprávy o vibracích vozidla a elektronickém plotu připomenutí vjezdu a výjezdu z vozidla a pochopte stav vozidla v reálném čase',
    uninstallTboxDesc: 'U vozidel, která nemají nainstalovaný T-Box, můžete po navázání zobrazit základní informace o vozidle, jako je číslo rámu, číslo motoru a elektronický manuál.',
    unitCurrencyPer: {},
    unitMonth: 'Měsíc',
    unlimited: 'Neomezené',
    unpaid: {},
    unprocessed: 'Neopracované',
    unresolved: 'Stále nemůžete vyřešit? Klikněte',
    unspecified: 'Důvěrnost údajů',
    upToTopics: 'Můžete přidat až do %s témat',
    updateAuthenticationTime: 'Aktualizovat čas ověření',
    updateBy: 'Aktualizátor',
    updateSuccess: {},
    updateTime: 'Čas aktualizace',
    updating: 'aktualizace',
    upgradeAgainDescription: 'Úloha upgradu byla znovu odeslána. Podle 【Průvodce】 v horní části aktuální stránky připojte síť displeje tft za účelem aktualizace.',
    upgradeAssistant: 'Pomoc',
    upgradeDescription: 'Až bude nalezena nová verze, postupujte podle 【Průvodce】 v horní části aktuální stránky a připojte zobrazovací síť tft pro upgrade.',
    upgradeSuccessful: 'Upgrade byl úspěšný',
    upgradeType: 'Metoda aktualizace',
    upload: 'nahrát',
    uploadDisplayPicture: {},
    uploadFail: 'Odeslání se nezdařilo',
    uploadFailed: 'Nahrávání se nezdařilo, zkuste jinou síť',
    uploadFailedOfTry: 'Nahrání se nezdařilo, zkuste to znovu',
    uploadFileMore1M: 'Velikost souboru nahrávání nepřesahuje 1M',
    uploadFiles: 'Nahrát soubor',
    uploadImageRules1To1: 'Formát obrázku musí být jpg/jpeg/png, s poměrem obrazu 1:1 a maximální velikostí 5MB',
    uploadLog: 'Nahrát log',
    uploadPicture: 'Nahrát obrázek',
    uploadQuantityExceed: 'Počet odeslaných souborů překračuje limit',
    uploadSuccessful: 'Nahrávání úspěšné',
    uploadTime: 'Čas nahrání',
    uploadTip556_740: {},
    uploadVideoRules: 'Podporováno je pouze jedno nahrání video souborů. Doporučuje se, aby velikost jednoho videa nepřesáhla 50 MB.',
    uploadVideoRules4To3: 'Podpora formátu videa, doporučený poměr 4:3, velikost nepřesahuje 50MB',
    urlLink: 'Odkaz URL',
    user: 'Uživatel',
    userEmail: 'poštovní schránka',
    userGender: 'Pohlaví uživatele',
    userId: 'ID uživatele',
    userIdTemplate: 'Šablona importu ID uživatele',
    userIdentity: 'uživatelské ID',
    userLocalTime: 'Místní čas uživatele',
    userLogin: 'Přihlášení',
    userMobilePhone: 'číslo mobilu',
    userModel: 'Model uživatelé',
    userName: 'uživatelské jméno',
    userName1: {},
    userNickname: 'Přezdívka uživatele',
    userNum: 'Číslo uživatele',
    userPhone: 'Číslo mobilního telefonu',
    userRealName: 'Skutečné jméno uživatele',
    userReply: 'Čekající odpověď uživatele',
    userStatus: 'Stav uživatele',
    userType: 'Typ uživatelé',
    userUnbind: 'Odpárovat uživatele',
    users: 'uživatelů',
    vacationTime: 'Doba dovolené',
    validNumberVolume: 'Počet platných cílů',
    validNumerDescription: 'Cílová skupina vybraná úlohou push a počet cílových zařízení po kontrole účinnosti',
    validateEmail: 'Nesprávný formát e-mailové adresy, prosím zkontrolujte.',
    validateImageRadio: 'Požadavky na formát obrazového souboru:  %s, poměr obrazu:  %s, ne na více než %s',
    validateImageSize: 'Požadavky na formát obrazového souboru:  %s, doporučená velikost obrázku:  %s, ne na více než %s',
    validatePhone: 'Chyba ve formátu telefonního čísla, zkontrolujte prosím',
    validateVideo: 'Požadavky na formát video souboru:  %s, ne na více než %s',
    validateVin: 'Chybné VIN, prosím zkontrolujte.',
    vehicleAlarmDetails: 'Podrobnosti o alarmu vozidla',
    vehicleBindDuration: 'Doba trvání vazby na vozidlo',
    vehicleBrochure: 'Brožura vozidla',
    vehicleColor: 'Barva vozidla',
    vehicleDetails: 'Podrobnosti o vozidle',
    vehicleDrivingLicense: 'Potvrzení o registraci vozidla.',
    vehicleFaultDetails: 'Podrobnosti o poruše vozidla',
    vehicleGallery: 'Galerie vozidel',
    vehicleGalleryEntranceConfiguration: 'Stránka moto showroomu APP a obrázky vstupu do funkce galerie vozidel jsou všechny převzaty z následující konfigurace. Ujistěte se, že jsou v konfiguraci dokončeny všechny tři obrázky.',
    vehicleGalleryEntranceSettings: 'Nastavení vstupu do galerie vozidel',
    vehicleGalleryUploadRules: 'Požadavek na formát obrázku je jpg/jpeg/png. Doporučuje se, aby velikost jednoho obrázku nepřesáhla 5 MB. Najednou lze importovat maximálně 10 obrázků. Vícenásobný import je povolen.',
    vehicleIdHomepageImage: 'Hlavní stránka potvrzení o registraci vozidla s uvedeným jménem vlastníka a VIN.',
    vehicleModel: 'Model vozidla',
    vehicleModelAlbum: 'Modelové album',
    vehicleModelCategorySort: 'Seřadit podle kategorie vozidla',
    vehicleModelDescription: 'Popis modelu',
    vehicleModelList: 'Seznam modelů',
    vehicleModelManagement: 'Správa modelů vozidel',
    vehicleModelName: 'Jméno modelu',
    vehicleModelQuery: 'Dotaz na model vozidla',
    vehicleModelSeries: 'Modelová řada',
    vehicleModelSorting: 'Třídění modelů',
    vehicleModelType: 'Typ modelu',
    vehicleName: 'Název vozidla',
    vehicleNetworkEquipment: 'Síťové zařízení vozidla',
    vehicleOutboundCountry: 'Odjezdová země vozidla',
    vehicleRemark: 'poznámky k vozidlu',
    vehicleShareInstruction: 'Pokyny pro sdílení vozidel',
    vehicleShareInstructionAdd: 'Nové instrukce pro sdílení vozidel',
    vehicleShareInstructionEdit: 'Upravit instrukce sdílení vozidel',
    vehicleType: 'č. motoru',
    vehicleTypeSplicing: 'Model zpětné vazby',
    vehicleUnbindingInstructions: 'Pokyny pro podání žádosti o rozvázání vozidla',
    versionCode: 'Číslo verze',
    versionIntroduction: 'Úvod verze',
    versionManage: 'Správa verzí',
    versionManageList: 'Seznam správy verzí',
    versionMangeTip:
      'Poznámka: Není povoleno vytvořit verzi větší, než je číslo verze aktuálně zveřejněné na trhu aplikací! Personál provozu a údržby musí počkat na vydání nejnovější verze na Google Play nebo App Store a poté vytvořit záznamy o verzi odpovídající nejnovějšímu číslu verze. Vytváření záznamů předem není povoleno.',
    versionPattern: 'Číslo verze lze zadat pouze jako celé číslo od 0 do 999.',
    versionRequired: 'Číslo verze nemůže být prázdné',
    video: 'Video',
    videoContent: 'Video obsah',
    videoCover: 'Obal videa',
    videoDetail: 'Podrobnosti o videu',
    videoDisplayImages: 'Zobrazení videa',
    videoFile: 'Video soubor',
    videoGuide: 'Konfigurace spouštění videa',
    videoImageValidate: 'Požadavky na formát souboru obrázku: png jpg jpeg, poměr obrázku 16:9, velikost ne více než 5 MB',
    videoList: 'Seznam videí',
    videoMaxSizeValidate: 'Velikost videa nesmí přesáhnout 150 MB',
    videoSizeExceed: 'Vă rugăm să încărcați un videoclip cu o lățime și înălțime de %s',
    viewAllComment: 'Zobrazit všechny recenze',
    viewCount: 'počet zhlédnutí',
    viewCurrentLocation: 'Otevřete APP a kdykoli zobrazíte aktuální polohu vozidla',
    viewCurrentLocation2: 'Otevřete APP a kdykoli si prohlédněte aktuální polohu vozidla, což je výhodné pro vyhledání vozidel z blízké vzdálenosti',
    viewDetails: 'Zobrazit detaily',
    viewFeedBackRecords: 'Zobrazit záznamy zpětné vazby',
    viewLocation: 'Otevřete APP a kdykoli zkontrolujte polohu vozidla',
    viewModel: {},
    viewPush: 'Zobrazit Push',
    viewSeries: {},
    viewVehicleInfomation: 'Podpora zobrazení denní jízdní dráhy, počtu najetých kilometrů, doby trvání, rychlosti a dalších informací o vozidle',
    views: 'Pohledy',
    vin: 'VIN',
    virginia: 'Virginie',
    waitForReview: 'Čekání na recenzi',
    waitUploading: 'Nahrávání, počkejte prosím',
    waitingManualReview: 'Čekání na ruční kontrolu',
    waitingOnline: {},
    waitingPush: 'Čekání',
    wednesday: 'Středa',
    whatOTA: 'Co je OTA?',
    whyUseNavigation: 'Jak používat navigaci',
    whyUseSetting: 'Jak provést obecná nastavení APP',
    withCountry: 'Země/oblast (IP)',
    withInformation: 'S informacemi',
    withTBOX: {},
    withdrawn: 'Odvoláno',
    withoutCarOfNumber: 'Počet uživatelů bez auta',
    withoutTBOX: {},
    writeAccountToPass: 'Vyplňte údaje o svém účtu a dokončete ověření totožnosti',
    year: {},
    yes: 'Ano',
    youHaveFeedbackMessage: 'Máte ** zpětnou vazbu od uživatelů, která nebyla efektivně řešena, vyřešte ji prosím včas',
    youthVehicleOwner: {},
    yoyGrowth: 'Navýšeno o  Meziročně',
    zh_CN: 'čínština',
  },
};
